module.exports = __webpack_public_path__ + "img/Q-A_icon.306572d4.png";